/** Advisor copy for empty states and onboarding (from default inspection / field-advisor prompts). */

export type AdvisorContent = {
  tagline: string;
  emptyDescription: string;
};

export const ADVISOR_CONTENT: Record<string, AdvisorContent> = {
  workmanship: {
    tagline: "Inspection — quality of the work itself",
    emptyDescription:
      "Inspects visible work product—masonry, concrete, carpentry, finishes, roofing, and envelope trades. Surfaces strengths and defects (completeness, durability, technique) with severity tags and supervisor-ready recommendations. Focuses on workmanship, not PPE, unless safety directly affects work quality.",
  },
  site_safety: {
    tagline: "Inspection — hazards and site conditions",
    emptyDescription:
      "Inspects safety, exposure, and site control—PPE, fall protection, scaffolding, lifts, housekeeping, staging, and access. Highlights what reduces risk versus what needs control, with severity on hazards like missing edge protection or blocked egress. Aimed at supervisors, foremen, and safety leads.",
  },
  analyze: {
    tagline: "Field Advisor — what’s wrong and what it means",
    emptyDescription:
      "Quinn teaches what a condition implies about the building envelope—root causes, hidden conditions, and water, movement, or durability risks. Prioritizes life safety, then scope versus estimate. Typical focus: findings, likely causes, and what it means (diagnostic, not step-by-step execution).",
  },
  execute: {
    tagline: "Field Advisor — how to do the work",
    emptyDescription:
      "Hank teaches how to carry out work safely, durably, and efficiently—methods, sequences, tie-ins, and alignment with manufacturer and code expectations. Flags unsafe or failure-prone methods. Typical focus: recommended method, key steps, and what to watch on site.",
  },
  review: {
    tagline: "Field Advisor — how it will be judged",
    emptyDescription:
      "Grace teaches how planned or completed work will land with CEO, client, and tenants—appearance, disruption, comfort, noise, cleanliness, access, and reputation. Weighs client expectations and visible quality. Typical focus: visual impact, tenant impact, and reputation risk.",
  },
};

export const ALL_ADVISORS_EMPTY_DESCRIPTION =
  "Each advisor reads this photo differently—work quality, site safety, diagnostics, field methods, or client impact. Select an advisor above, then use Run to generate up to six distinct insights.";

export const getAdvisorContent = (personaId: string): AdvisorContent | undefined =>
  ADVISOR_CONTENT[personaId];

export const getAdvisorTagline = (personaId: string): string =>
  ADVISOR_CONTENT[personaId]?.tagline ?? "AI advisor";

export const getAdvisorEmptyDescription = (personaId: string): string =>
  ADVISOR_CONTENT[personaId]?.emptyDescription ??
  "Run analysis to generate insights for this advisor on this image.";
